import React, { useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { walletApi } from "../services/wallet";
import "./GoogleWalletButton.css";
import { t } from "../i18n";

// Android twin of the Apple Wallet badge on the Live QR page. The server
// hands back Google's "save" link; Google shows its own Add-to-Wallet sheet.
// The badge is Google's official artwork (public/add-to-google-wallet.svg).
export const isAndroid = (): boolean =>
  Capacitor.getPlatform() === "android" || /Android/i.test(navigator.userAgent || "");

const GoogleWalletButton: React.FC = () => {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      const { url } = await walletApi.googleSaveLink();
      // In the app the link opens in the browser sheet, which hands off to
      // the Wallet app; on the web it is a plain navigation.
      if (Capacitor.isNativePlatform()) await Browser.open({ url });
      else window.location.href = url;
    } catch (err) {
      console.error("Failed to open Google Wallet pass:", err);
      alert(t("googleWalletButton.couldnTOpenYour"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="google-wallet-row">
      <button
        type="button"
        className="google-wallet-badge"
        onClick={handleClick}
        disabled={busy}
        aria-label={t("googleWalletButton.addToGoogleWallet")}
      >
        <img src="/add-to-google-wallet.svg" alt="" />
      </button>
    </div>
  );
};

export default GoogleWalletButton;
